module.exports = __webpack_public_path__ + "media/images/advents-calendar-grafik-fa883ac77022e1ce40324c54bb7e0212.svg";